import { Link, useLocation } from "react-router-dom";
import { Home, Wrench, ShoppingCart, Shield, User } from "lucide-react";
import { useAuth } from "@/App";

export default function BottomNavigation() {
  const location = useLocation();
  const { user } = useAuth();
  
  const navItems = [
    { path: "/", label: "Home", icon: Home },
    { path: "/maintenance", label: "Maintenance", icon: Wrench },
    { path: "/order-request", label: "Orders", icon: ShoppingCart },
  ];
  
  // Add admin/worker link based on role
  if (user) {
    if (user.role === "super_admin" || user.role === "hub_admin") {
      navItems.push({ path: "/admin", label: "Admin", icon: Shield });
    } else if (user.role === "maintenance_worker") {
      navItems.push({ path: "/worker", label: "My Work", icon: User });
    }
  } else {
    navItems.push({ path: "/login", label: "Staff", icon: Shield });
  }
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-t border-slate-200/50 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:hidden">
      <div className="flex items-center justify-around px-2 py-2 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
            (item.path !== "/" && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-1 px-4 py-2 rounded-2xl transition-all duration-300 ${
                isActive 
                  ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/30 scale-105' 
                  : 'text-slate-500 hover:text-blue-600 hover:bg-blue-50'
              }`}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'animate-bounce-subtle' : ''}`} />
              <span className="text-[10px] font-semibold">{item.label}</span>
            </Link>
          );
        })}
      </div>
      
      {/* Safe area padding for notched phones */}
      <div className="h-safe-area-inset-bottom bg-white" />
    </nav>
  );
}
